<template>
    <div>
        <h6>Data will be reported to:</h6>
        <div class="form-check form-check-inline pr-5">
            <input class="form-check-input" type="radio" id="inlineRadio1" value="ftp" v-model="loggingMethod" @change="updateLoggingMethod">
            <label class="form-check-label" for="inlineRadio1">FTP</label>
        </div>
        <div class="form-check form-check-inline pr-5">
            <input class="form-check-input" type="radio" id="inlineRadio2" value="http" v-model="loggingMethod" @change="updateLoggingMethod">
            <label class="form-check-label" for="inlineRadio2">HTTP</label>
        </div>
        <div class="form-check form-check-inline pr-5">
            <input class="form-check-input" type="radio" id="inlineRadio3" value="cumulocity" v-model="loggingMethod" @change="updateLoggingMethod">
            <label class="form-check-label" for="inlineRadio3">Cumulocity</label>
        </div>
        <div class="form-check form-check-inline pr-5">
            <input class="form-check-input" type="radio" id="inlineRadio4" value="mqtt" v-model="loggingMethod" @change="updateLoggingMethod">
            <label class="form-check-label" for="inlineRadio4">MQTT</label>
        </div>
        <div class="form-check form-check-inline pr-5">
            <input class="form-check-input" type="radio" id="inlineRadio5" value="azure" v-model="loggingMethod" @change="updateLoggingMethod">
            <label class="form-check-label" for="inlineRadio5">Azure</label>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loggingMethod: 'ftp'
        }
    },
    methods: {
        updateLoggingMethod() {
            this.$nextTick(() => {
                this.$emit('loggingMethodUpdated', this.loggingMethod)
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/server-forms/ServerSelection.vue